/*
 * "Friendly" error messages.
 */

import type { ApiError } from 'api/api-util/api-error';

/**
 * Errors from updating bank account numbers.
 *
 * See endpoint: /banks/:bank_id/dispensary/:dispensary_id/metadata
 *
 * @param error from a catch clause.
 * @returns a friendly error message.
 */
export const lookupAccountNumberError = (error: ApiError) => {
  let friendlyMessage = 'An unexpected error occurred. Please try again or contact support for help';

  if (error.hasCustomMessage) {
    const message = error.message;

    switch (message) {
      case 'Internal MUO ID already in use':
        friendlyMessage =
          'The account number you are trying to enter is already in use. Please change it and try again or contact support for help.';
        break;
      case 'Internal Dispensary ID already in use':
        friendlyMessage =
          'The account number you are trying to enter is already in use. Please change it and try again or contact support for help.';
        break;
      case 'Internal Dispensary ID must be unique in this MUO':
        friendlyMessage =
          'There was an issue when trying to approve this account. The account number must be unique for this child location. Please change it and try again or contact support for help.';
        break;
      default:
        // Keep the catch-all message.
        break;
    }
  }

  return friendlyMessage;
};
